export const COLLAPSED = {
  WIDTH: 376,
  HEIGHT: 70,
};

export const COLLAPSED_AS_ROUNDED = {
  WIDTH: 100,
  HEIGHT: 90,
};

export const COLLAPSED_WITH_MESSAGE_NOTIFICATION = {
  WIDTH: 376,
  HEIGHT: 310,
};

export const EXPANDED_WITH_MESSAGE_NOTIFICATION = {
  WIDTH: 376,
  HEIGHT: 647,
};

export const EXPANDED = {
  WIDTH: 376,
  HEIGHT: 549,
};
